import { MESSAGE_URL, SIGN_IN_URL } from '../../constants/AppUrlConstants';
import Auth from '../Auth';

const handleAuthErrors = ({
  error,
  errorMessage,
  errorTitle,
  navigate,
  nonAuthRedirectUrl,
  redirectUrl,
  ...props
}) => {
  let errorResponse;

  // const stateToPersist = {
  //   ...props?.state?.state,
  //   redirectURL: redirectUrl,
  // };

  if (error?.response?.status === 422 || error?.response?.status === 401) {
    const stateToPersist = { ...props?.state?.state, redirectURL: redirectUrl };
    Auth.removeToken();
    navigate(SIGN_IN_URL, { state: { ...stateToPersist } });
  } else {
    const stateToPersist = { ...props?.state?.state, redirectURL: nonAuthRedirectUrl || redirectUrl };
    navigate(MESSAGE_URL, {
      state: {
        title: errorTitle || 'Something has gone wrong',
        message: errorMessage || undefined,
        ...stateToPersist,
      },
    });
  }

  return errorResponse;
};

export default handleAuthErrors;
